
import { defineComponent } from 'vue'
import { useStore } from '@/store/index'
import { mdiMenu, mdiClose, mdiPlayBoxOutline, mdiCalendarCheck, mdiEmailCheck } from '@mdi/js'

import BaseAvatar from '@/components/BaseAvatar.vue'
import BaseIconText from '@/components/BaseIconText.vue'
import BaseLogo from '@/components/BaseLogo.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'
import SearchBox from '@/components/SearchBox.vue'
import { HOME_PATH } from '@/router/routes'

export default defineComponent({
  components: { BaseIconText, BaseAvatar, BaseLogo, LayoutsAuthWidth, SearchBox },
  setup() {
    const store = useStore()

    return {
      store,
      mdiMenu,
      mdiClose,
      mdiPlayBoxOutline,
      mdiCalendarCheck,
      mdiEmailCheck,
      homePath: HOME_PATH
    }
  },
})
